<template>
  <div>
    <loading :active=avatarLoading :is-full-page="false"></loading>
    <div class="upload-avatars-list" v-if="!avatarLoading">
      <div
          class="avatar-holder"
          :class="{selected: avatarSrc === src}"
          v-for="src in uploadedAvatars"
          :key="src">
        <img :src="src" alt="avatar" @click="chooseCustomAvatar(src)">
        <div class="remove-avatar-btn" @click="removeAvatarImage(src)">
          <svg width="25" height="32" fill="#7E7E7E">
            <use xlink:href="#icon-trash"></use>
          </svg>
        </div>
      </div>
      <div
          class="avatar-holder"
          :class="{selected: (+idx === defaultAvatarId) && defaultAvatarUsed}"
          v-for="(val, idx) in $avatars"
          :key="idx"
          @click="chooseDefaultAvatar(idx)">
        <svg class="size-placeholder" viewBox="0 0 1 1" version="1.1" xmlns="http://www.w3.org/2000/svg"></svg>
        <img :src="val" alt="avatar" />
      </div>
    </div>
    <div class="mt-1">
      <button class="btn btn-outline mr-1" @click="selectFile">{{ $lang.messages.add_profile.upload_avatar }}</button>
      <button class="btn btn-main -shadow" @click="$emit('hidechooseavatar')">{{ $lang.messages.save }}</button>
    </div>
    <input ref="file" type="file" accept="image/jpeg, image/png" class="hidden" @change="uploadImage"/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import firebase from "firebase/app"
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: "ChooseAvatar",
  components: {Loading},
  data: function (){
    return {
      avatarSrc: false,
      avatarLoading: false,
      avatarLimitError: false,
      defaultAvatarId: Math.ceil(Math.random() * 13), // default avatars count
      uploadedAvatars: [],
      defaultAvatarUsed: true,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      profiles: state => state.accountData.profiles,
    }),
    storageID() {
      return this.user.isLinked ? this.user.mainUid : this.user.uid;
    }
  },
  mounted() {
    this.avatarLoading = true
    const storageRef = firebase.storage().ref(`avatars/${this.storageID}`);

    storageRef.listAll().then((result) => {
      if(result.items.length){
        result.items.forEach((imageRef) => {
          imageRef.getDownloadURL().then((url) => {
            this.uploadedAvatars.push(url);
            this.avatarLoading = false
          }).catch(function(error) {
            console.log('error', error);
          });
        });
      } else {
        this.avatarLoading = false
      }
    }).catch(function(error) {
      console.log('error', error);
    });
  },
  methods: {
    selectFile: function () {
      this.$refs.file.click();
    },
    uploadImage: function (e) {
      this.avatarLimitError = false
      const file = e.target.files[0];
      if (file.size < 1000000) {
        const imageHash = Date.now()
        const storePath = `avatars/${this.storageID}/${file.name}?${imageHash}`;
        const storage = firebase.storage().ref(storePath)
        this.avatarLoading = true;
        storage.put(file)
            .then(async () => {
              const url = await storage.getDownloadURL();
              this.avatarSrc = url;
              this.avatarLoading = false;
              this.$emit('changeavatar', url);
              this.uploadedAvatars.push(url);
            })
            .catch(d => console.log(d))
      } else {
        this.$dtoast.pop({
          preset: "error",
          heading: this.$lang.messages.add_profile.avatar_error,
        });
      }
    },
    chooseCustomAvatar(avatarSrc) {
      this.avatarSrc = avatarSrc;
      this.$emit('changecustomavatar', avatarSrc)
      this.defaultAvatarUsed = false;
    },
    chooseDefaultAvatar(idx) {
      this.defaultAvatarId = parseInt(idx);
      this.$emit('changeavatar', this.defaultAvatarId)
      this.defaultAvatarUsed = true;
      this.avatarSrc = null;
    },
    removeAvatarImage(src) {
      const ref = firebase.storage().refFromURL(src);

      ref.delete().then(() => {
        this.uploadedAvatars = this.uploadedAvatars.filter(itemSrc => itemSrc !== src);
        this.defaultAvatarUsed = true;
        this.avatarSrc = null;
        this.$emit('changeavatar', null)
        this.$emit('changecustomavatar', null)
        this.defaultAvatarId = 1;
      })

      Object.keys(this.profiles).forEach((key) => {
        if(this.profiles[key].avatar === src){
          this.saveProfileSettings(key, {
            avatar: null
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>